export const IMPORT_FROM_AI_ASSISTANT = 'ai-assistant'
export const IMPORT_FROM_SCRIPT = 'script'

export function useImportFrom() {
  const searchParams = new URLSearchParams(window.location.search)

  const isImportFromAiAssistant = searchParams.get(IMPORT_FROM_AI_ASSISTANT) === '1'
  const isImportFromScript = searchParams.get(IMPORT_FROM_SCRIPT) === '1'

  return {
    isImportFromAiAssistant,
    isImportFromScript,
  }
}
